import { Button, ButtonProps, useModal, Text } from 'uikit'
import useLocalDispatch from 'contexts/LocalRedux/useLocalDispatch'
import { useCollectWinningModalProps } from 'state/predictions/hooks'
import { useConfig } from '../context/ConfigProvider'
import CollectRoundWinningsModal from './CollectRoundWinningsModal'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useReferralCode } from 'state/predictions/hooks'

interface CollectWinningsButtonProps extends ButtonProps {
  hasClaimed: boolean
  onSuccess?: () => Promise<void>
}

const PrizePopBg = styled.div`
  width: 300px;
  height: 195px;
  background: #ffffff;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const ImgCup = styled.img`
  width: 102px !important;
  height: 68px !important;
  margin-bottom: 5px;
`

const CollectWinningsButton: React.FC<CollectWinningsButtonProps> = ({ hasClaimed, onSuccess, children, ...props }) => {
  const { history, isLoadingHistory } = useCollectWinningModalProps()
  const dispatch = useLocalDispatch()
  const { address: predictionsAddress, token } = useConfig()
  const { t } = useTranslation()
  const referralCode = useReferralCode()

  const [onPresentCollectWinningsModal] = useModal(
    <CollectRoundWinningsModal
      dispatch={dispatch}
      history={history}
      isLoadingHistory={isLoadingHistory}
      onSuccess={onSuccess}
      predictionsAddress={predictionsAddress}
      token={token}
      code={referralCode}
    />,
    false,
    true,
    'CollectRoundWinningsModal'
  )

  return (
    <PrizePopBg>
      <ImgCup src={require('assets/images/prediction/winner.png').default} />
      <Text fontSize="14px" bold mb="18px">
        {t('PREDICTION_31')}
      </Text>
      <Button height="40px" onClick={onPresentCollectWinningsModal} disabled={hasClaimed} {...props}>
        {children}
      </Button>
    </PrizePopBg>
  )
}

export const CollectWinningsNormalButton: React.FC<CollectWinningsButtonProps> = ({
  hasClaimed,
  onSuccess,
  children,
  ...props
}) => {
  const { history, isLoadingHistory } = useCollectWinningModalProps()
  const dispatch = useLocalDispatch()
  const { address: predictionsAddress, token } = useConfig()
  const referralCode = useReferralCode()

  const [onPresentCollectWinningsModal] = useModal(
    <CollectRoundWinningsModal
      dispatch={dispatch}
      history={history}
      isLoadingHistory={isLoadingHistory}
      onSuccess={onSuccess}
      predictionsAddress={predictionsAddress}
      token={token}
      code={referralCode}
    />,
    false,
    true,
    'CollectRoundWinningsModal'
  )

  return (
    <Button height="40px" onClick={onPresentCollectWinningsModal} disabled={hasClaimed} {...props}>
      {children}
    </Button>
  )
}

export default CollectWinningsButton
